export default __webpack_public_path__ + "static/media/pic9.722ec2ab.jpg";